import { Tradable, TradableAdapter } from "@modules/+new/core/tradables/domain/entities/tradable";
import { SecurityToken as OldSecurityToken } from "@models/asset/cryptocoins/currencies/security_token";
import { TRADABLES_TYPE } from "@helpers/constants";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface SecurityToken extends Tradable {}

export class SecurityTokenAdapter extends TradableAdapter {
	public adapt(coin: OldSecurityToken): SecurityToken {
		const tradable = super.adapt(coin);
		return {
			...tradable,
			type: TRADABLES_TYPE.SECURITY_TOKEN
		};
	}
}
